if ('serviceWorker' in navigator && 'BeforeInstallPromptEvent' in window) {
    window.addEventListener('load', () => {
        const installWrapper = document.querySelector('.install_wrapper');
        const closeButton = document.querySelector('.app_install-close');
        const btnAdd = document.querySelectorAll('.install_app');
        const isHidden = localStorage.getItem('isHiddenInstall');

        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();

            const installButton = document.getElementById('install-btn');
            installButton.style.display = 'block';
            let deferredPrompt = event;

            function handleInstallClick() {
                deferredPrompt.prompt();
                deferredPrompt.userChoice.then((choiceResult) => {
                    deferredPrompt = null;
                    localStorage.setItem('isHiddenInstall', true);
                    installWrapper.style.display = 'none';
                });
            }

            if (btnAdd) {
                btnAdd.forEach((installAppBtn) => {
                    installAppBtn.addEventListener('click', handleInstallClick);
                });
            }
            installButton.addEventListener('click', handleInstallClick);
        });

        if (! isHidden) {
            installWrapper.style.display = 'block';
        }

        closeButton.addEventListener('click', (e) => {
            installWrapper.style.display = 'none';
            localStorage.setItem('isHiddenInstall', true);
        });

        if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
            const btnInstallWrap = document.querySelectorAll('.btn-install-wrap');
            if (btnInstallWrap) {
                btnInstallWrap.forEach((installBtnWrap) => {
                    installBtnWrap.style.display = 'none';
                });
            }
            installWrapper.style.display = 'none';
        }
    });
}
